import React, { useEffect, useState } from "react";
// import { FundEditModal } from "../modals/FundEditModal";
import { FaEdit, FaRegEdit } from "react-icons/fa";
import { isEmpty } from "lodash";
import HierarchicalTable from "./HierarchicalTable";
import axios from "axios";
import Swal from "sweetalert2";
import api from "../../../../utils/api";
// import { DiscardReasonModal } from "../modals/DiscardReasonModal";
import { useSelector } from "react-redux";
import { formatRupees } from "../../../../utils/inputsValidation";
import HierarchicalTableNew from "./HierarchicalTableNew";

export const TabFour = ({
  setSelectedTab,
  selectedTab,
  isPortfolioData,
  roomId,
  setSelectedMember,
  selectedMember,
  fetchPortfolioData,
  rowActions, setRowActions
  , schemeCode, setSchemeCode, isPortfolioDataNEW
}) => {
  console.log("isPortfolioData", isPortfolioData, isPortfolioDataNEW);
  const [grandTotal, setGrandTotal] = useState({
    Amount: 0,
    CurrentValue: 0,
    Gainloss: 0,
    Cagr: 0,
    AbsReturn: 0,
  });
  const [bankDetails, setBankDetails] = useState([]);

  const {
    clientData,
    loading: clientLoading,
    error: clientError,
  } = useSelector((state) => state.client);



  const [allowedReview, setAllowedReview] = useState(false);
  const [allowDiscard, setAllowDiscard] = useState(false);
  const [isGrandtotal, setIsGrandTotal] = useState(0); // Only for CurrentValue

  const [isChecked, setIsChecked] = useState(false);

  const [perUserEffectiveTotals, setPerUserEffectiveTotals] = useState([]);

  useEffect(() => {
    console.log("heresssss", isPortfolioData?.data?.result3?.length);
    if (isPortfolioData?.data?.result3?.length > 0 || isPortfolioDataNEW?.data?.result3?.length > 0) {
      const values = calculateEffiBalTotal();
      setPerUserEffectiveTotals(values); // Save per-user values for child display
    }
  }, [isChecked, isPortfolioData, isPortfolioDataNEW]);

  const getFromDate = (fundNameType, subName) => {
    if (
      (fundNameType === "Equity" && subName !== "Equity - ELSS") ||
      (fundNameType === "Hybrid" && subName !== "Hybrid - Arbitrage")
    ) {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1)); // -12 months
    } else if (
      ["Debt", "Hybrid - Arbitrage", "Others"].includes(fundNameType)
    ) {
      return new Date(); // Today
    } else {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 3)); // -36 months
    }
  };
  const [folioDataa, setfolioData] = useState();
  // console.log("folioDataa", folioDataa);

  const fundtotal = isPortfolioData?.data?.result3 || isPortfolioDataNEW?.data?.result3?.user;

  // console.log("All Portfolio detail:", fundtotal);

  const calculateEffiBalTotal = () => {
    let total = 0;
    const perUserValues = [];

    fundtotal?.forEach((userData) => {
      let userTotal = 0;

      if (!Array.isArray(userData) || userData.length === 0) return;

      if (isChecked) {
        userData.forEach((user) => {
          const portfolioData = user?.Portfoio
            ? Object.values(user.Portfoio)
            : [];

          portfolioData.forEach((item) => {
            item?.Detail?.forEach((subFund) => {
              subFund?.Detail?.forEach((subFundDetail) => {
                const txns = subFundDetail?.Transaction || [];
                const fundnametype = item["Fund Name"];
                const fundSubName = subFund["Fund Sub Name"];

                let fromDate = new Date();
                if (
                  (fundnametype === "Equity" &&
                    fundSubName !== "Equity - ELSS") ||
                  (fundnametype === "Hybrid" &&
                    fundSubName !== "Hybrid - Arbitrage")
                ) {
                  fromDate.setMonth(fromDate.getMonth() - 12);
                } else if (
                  ["Debt", "Hybrid - Arbitrage", "Others"].includes(
                    fundnametype
                  )
                ) {
                  // no change
                } else {
                  fromDate.setMonth(fromDate.getMonth() - 36);
                }

                const validTypes = [
                  "SIP Purchase",
                  "Purchase",
                  "STP In",
                  "Switch In",
                ];

                txns.forEach((tx) => {
                  const parts =
                    tx["Transaction Date"]?.replace(/-/g, "/")?.split("/") ||
                    [];
                  if (parts.length === 3) {
                    let [dd, mm, yy] = parts;
                    if (yy.length === 2) yy = "20" + yy;
                    const txDate = new Date(`${yy}-${mm}-${dd}`);

                    if (
                      !isNaN(txDate) &&
                      validTypes.includes(tx["Transaction Type"]) &&
                      txDate < fromDate
                    ) {
                      userTotal += parseFloat(tx["Current Value"] || 0);
                    }
                  }
                });
              });
            });
          });
        });
      } else {
        // ✅ use Grand Total -> Current Value when unchecked
        userTotal = parseFloat(
          userData?.[0]?.["Grand Total"]?.["Current Value"] || 0
        );
      }

      perUserValues.push(userTotal.toFixed(2));
      total += userTotal;
    });
    console.log("im called", isChecked);
    setIsGrandTotal(total.toFixed(2));
    return perUserValues;
  };

  const handleAddCurrentValue = (val) => {
    setIsGrandTotal((prev) => prev + (val || 0));
  };
  const innerFirstIndexData =
    Array.isArray(fundtotal) && fundtotal.length > 0
      ? Array.isArray(fundtotal[0]) && fundtotal[0].length > 0
        ? fundtotal[0][0]
        : "Inner detail at index [0] is not a valid array or is empty."
      : "Fundtotal is not a valid array or is empty.";

  const portfoioData = innerFirstIndexData?.Portfoio
    ? Object.values(innerFirstIndexData.Portfoio)
    : "Portfoio property not found";

  // console.log("Extracted Portfoio detail:", portfoioData);

  console.log("isportfoliodata", isPortfolioData);

  // Function to handle "Back" button click
  const handleBack = () => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
    }
  };


  const isPortfolioLoading = (!isPortfolioData || Object.keys(isPortfolioData).length === 0);
  const isPortfolioLoadingNew = (!isPortfolioDataNEW || Object.keys(isPortfolioDataNEW).length === 0);


  const prst = (isPortfolioData?.data?.prinfo?.portfolio_review_status ||
    isPortfolioDataNEW?.data?.prinfo?.portfolio_review_status) ?? null;

  console.log("prst", isPortfolioLoading, isPortfolioLoadingNew);

  // const allowedReview = ["Draft", "Failed", "Rejected"].includes(prst);
  // const allowDiscard = prst === "Sent";


  React.useEffect(() => {
    // reset both first
    setAllowedReview(false);
    setAllowDiscard(false);

    if (["Draft", "Failed", "Rejected"].includes(prst)) {
      setAllowedReview(true);
    } else if (prst === "Sent") {
      setAllowDiscard(true);
    }
  }, [prst, setAllowedReview, setAllowDiscard]);


  const updateClientDates = async (data2) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE}client/update-client-dates`,
        data2
      );
    } catch (error) {
      console.error("Error fetching AllExternal Folios data:", error);
    }
  }

  const handleSendPortFolio = async () => {
    const allData = {
      clientid: isPortfolioData?.data?.prinfo.client_id,
      pr_id: isPortfolioData?.data?.prinfo.portfolio_review_id,
      remark: "",
    };

    try {
      const { data } = await api.post(
        `advisor/sendportfolioWm`, allData
      );


      // 1) Error case — stop flow
      if (data?.isError) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: data?.message || "An error occurred while sending the portfolio.",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });
        return; // stop here on error
      }

      // 2) Warning case — run fetch only after OK if you want
      if (data?.isWarning) {
        const warnRes = await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Client is not enabled for online transactions.",
          footer: "<b>Please review the portfolio for further details.</b>",
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });

        if (warnRes.isConfirmed) {
          const data2 = {
            _id: roomId,
            action: "pr_date",
            date: new Date(),
          };
          await updateClientDates(data2);
          await fetchPortfolioData(); // runs only when user clicks OK
        }
        return; // done after handling warning
      }

      // 3) Success case — update dates, then fetch after OK
      const okRes = await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Portfolio has been successfully sent to the client for approval.",
        confirmButtonText: "OK",
        customClass: { confirmButton: "swal-confirm-btn" },
      });

      if (okRes.isConfirmed) {
        const data2 = {
          _id: roomId,
          action: "pr_date",
          date: new Date(),
        };
        updateClientDates(data2);

        await fetchPortfolioData(); // only after OK
      }
    } catch (error) {
      // Handle API call errors
      console.error("Error sending portfolio data:", error);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to send the portfolio. Please try again later.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
    }
  };

  // const [isShowDiscardReasonModal, setIsShowDiscardReasonModal] = useState(false);

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;

    const selectedData = bankDetails.find(
      (member) => member._id === selectedId
    );
    console.log("selectedData", selectedData);
    setSelectedMember(selectedData);
    setSelectedTab(1);
  };
  console.log("selectedMember", selectedMember, isPortfolioData);

  useEffect(() => {
    getInvestor();
  }, []);

  // Fetch Investor Name fund list from API
  const getInvestor = async () => {
    try {
      const response = await api.get(`advisor/gethouseHoldPanInfo/${roomId}`
      );
      setBankDetails(response.data);
      console.log("BankDetails", response.data);
    } catch (error) {
      console.error("Error fetching AMC fund list:", error);
    }
  };
  useEffect(() => {
    // Ensure isPortfolioData exists and has result3
    if (isPortfolioDataNEW?.data?.result3?.users?.length > 0) {
      console.log("ddd", isPortfolioDataNEW?.data?.result3?.grandTotals);

      setGrandTotal(isPortfolioDataNEW?.data?.result3?.grandTotals);
      return;
    }

    if (!isPortfolioData?.data?.result3 || isPortfolioData?.data?.result3.length === 0)
      return;

    const data = isPortfolioData?.data?.result3
    console.log("ddd", data);

    const newTotal = {
      Amount: 0,
      CurrentValue: 0,
      Gainloss: 0,
      Cagr: 0,
      AbsReturn: 0,
    };


    data.flat().forEach((item) => {
      const grandTotal = item?.["Grand Total"]; // Handling "Grand Total"

      if (grandTotal) {
        newTotal.Amount += parseFloat(grandTotal?.["Amount"]) || 0;
        newTotal.CurrentValue += parseFloat(grandTotal?.["Current Value"]) || 0;
        newTotal.Gainloss += parseFloat(grandTotal?.["Gainloss"]) || 0;
        newTotal.Cagr += parseFloat(grandTotal?.["Cagr"]) || 0;
        newTotal.AbsReturn += parseFloat(grandTotal?.["AbsReturn"]) || 0;
      }
    });
    console.log("newTotal", newTotal);

    setGrandTotal(newTotal);
  }, [isPortfolioData?.data?.result3?.length, isPortfolioDataNEW?.data?.result3?.length]);


  return (
    <>
      {/* <DiscardReasonModal
        advisorId={clientData.advisor_id}
        show={isShowDiscardReasonModal}
        onHide={() => setIsShowDiscardReasonModal(false)}
        isPortfolioData={isPortfolioData}
        fetchPortfolioData={fetchPortfolioData}
      /> */}


      <div className="container" style={{ minHeight: "500px" }}>
        {/* for old data */}
        {isPortfolioLoading ? (
          <></>
        ) : (
          <>
            <div className="row">
              <div className="col">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home-tab-pane"
                    role="tabpanel"
                  >
                    <div className="row pb-4 align-items-center">
                      {/* Left Side: Label & Dropdown */}
                      <div className="col-md-6 col-12 mb-2">
                        <label className="fs-14 fw-normal clrlight">
                          Live portfolio of
                        </label>
                        <select
                          className="form-select w-50 w-md-25"
                          aria-label="Default select example"
                          onChange={handleSelectChange}
                          value={selectedMember?._id}
                        >
                          {!bankDetails?.some(
                            (member) => member.type === "Individual"
                          ) && <option value="all_Household">Household</option>}

                          {bankDetails?.map((member) => (
                            <option key={member._id} value={member._id}>
                              {member.client_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Right Side: Last Review Date */}
                      {/* <div className="col-md-6 col-12 text-md-end text-left mt-md-3 mt-2">
                        <p>
                        Last portfolio review -{" "}
                        {clientData?.lastportfolioreview_at &&
                          new Date(clientData.lastportfolioreview_at).toLocaleDateString("en-US", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })}
                          </p>
                          
                          
                          
                          </div> */}
                    </div>


                    <div className="row  d-md-block">
                      {isPortfolioData?.data?.result3?.map((item, index) => (
                        <div key={index}>
                          <HierarchicalTable
                            allowedReview={allowedReview}
                            schemeCode={schemeCode} setSchemeCode={setSchemeCode}
                            rowActions={rowActions} setRowActions={setRowActions}
                            onlyone={index === 0 ? "yes" : "no"}
                            userData={item}
                            isPortfolioData={isPortfolioData}
                            fetchPortfolioData={fetchPortfolioData}
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            effectiveValue={
                              perUserEffectiveTotals?.[index] || 0
                            }
                          />
                        </div>
                      ))}
                    </div>


                    {!selectedMember?.wo_id && (
                      <>
                        {/* Grand Total Row (desktop only) */}
                        <div className="d-none d-md-block mb-5">
                          <div className="d-flex w-100 align-items-center bg-light ps-2 py-2 border-top border-bottom">

                            {/* Column 1 - Label */}
                            <div style={{ width: "20%" }} className="fw-bold">
                              Grand Total
                            </div>

                            {/* Column 2 - Inv Cost */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {formatRupees(grandTotal?.Amount || 0)}
                            </div>

                            {/* Column 3 - Current Value / Load Free Unit */}
                            <div style={{ width: "14%" }} className="fw-bold text-end">
                              {formatRupees(isGrandtotal || 0)}
                            </div>

                            {/* Column 4 - Gain/Loss */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {formatRupees(grandTotal?.Gainloss || 0)}
                            </div>

                            {/* Column 5 - CAGR */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {/* {grandTotal?.Cagr ?? "N/A"} */}
                            </div>

                            {/* Column 6 - Abs Return */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {/* {grandTotal?.["Abs Return"] ?? "N/A"} */}
                            </div>

                            {/* Column 7 - Goal */}
                            <div style={{ width: "10%" }}></div>

                            {/* Column 8 - Action */}
                            <div style={{ width: "16%" }}></div>
                          </div>
                        </div>


                        {/* For Mobile view  Start*/}

                        <div className="row my-5 d-block d-md-none">
                          <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                            <div className="d-flex justify-content-between my-3  ">
                              <strong>Grand Total</strong>

                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Inv Cost</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.Amount)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Current Val</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.CurrentValue)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Gain/Loss</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.Gainloss)}
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* For Mobile view End */}

                      </>
                    )}

                    <div id="actiocentercls" style={{ textAlign: "center" }}>
                      {/* {allowedReview && ( */}
                      {/* <>
                        {prst === "Draft" && (
                          <button
                            className="lrgbutton upercase  text-white"
                            id="validatesubmit"
                            onClick={handleSendPortFolio}
                          >
                            Send
                          </button>
                        )}
                        {(prst === "Failed" || prst === "Rejected") && (
                          <button
                            className="lrgbutton upercase  text-white"
                            id="validatesubmitresent"
                          >
                            Resend
                          </button>
                        )}
                      </> */}
                      {/* )} */}
                      {/* {allowDiscard && ( */}
                      {/* {prst === "Sent" &&
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="rechangeportfolio"
                          onClick={() => setIsShowDiscardReasonModal(true)}
                        >
                          Discard
                        </button>
                      } */}
                      {/* )} */}
                      {/* <button className="lrgbutton upercase  text-white ms-2" id="rechangeportfolio" onClick={()=>setIsShowDiscardReasonModal(true)}>
            Discard
            </button> */}

                      {/* {isPortfolioData?.data?.prinfo?.accepted_once && (
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="pushToArchive"
                        >
                          Archive
                        </button>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* for new data */}
        {isPortfolioLoadingNew ? (
          <></>
        ) : (
          <>
            <div className="row">
              <div className="col">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home-tab-pane"
                    role="tabpanel"
                  >
                    <div className="row pb-4 align-items-center">
                      {/* Left Side: Label & Dropdown */}
                      <div className="col-md-6 col-12 mb-2">
                        <label className="fs-14 fw-normal clrlight">
                          Live portfolio of
                        </label>
                        <select
                          className="form-select w-50 w-md-25"
                          aria-label="Default select example"
                          onChange={handleSelectChange}
                          value={selectedMember?._id}
                        >
                          {!bankDetails?.some(
                            (member) => member.type === "Individual"
                          ) && <option value="all_Household">Household</option>}

                          {bankDetails?.map((member) => (
                            <option key={member._id} value={member._id}>
                              {member.client_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Right Side: Last Review Date */}
                      {/* <div className="col-md-6 col-12 text-md-end text-left mt-md-3 mt-2">
                        <p>
                        Last portfolio review -{" "}
                        {clientData?.lastportfolioreview_at &&
                          new Date(clientData.lastportfolioreview_at).toLocaleDateString("en-US", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })}
                          </p>
                          
                          
                          
                          </div> */}
                    </div>


                    <div className="row  d-md-block">
                      {isPortfolioDataNEW?.data?.result3?.users?.map((item, index) => (
                        <div key={index}>
                          {/* {item?.username} */}
                          <HierarchicalTableNew
                            userData={item}
                            allowedReview={allowedReview}
                            schemeCode={schemeCode} setSchemeCode={setSchemeCode}
                            rowActions={rowActions} setRowActions={setRowActions}
                            isPortfolioData={isPortfolioDataNEW}
                            onlyone={index === 0 ? "yes" : "no"}
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                            effectiveValue={
                              perUserEffectiveTotals?.[index] || 0
                            }
                          />
                        </div>
                      ))}
                    </div>


                    {!selectedMember?.wo_id && (
                      <>
                        {/* Grand Total Row (desktop only) */}
                        <div className="d-none d-md-block mb-5">
                          <div className="d-flex w-100 align-items-center bg-light ps-2 py-2 border-top border-bottom">

                            {/* Column 1 - Label */}
                            <div style={{ width: "20%" }} className="fw-bold">
                              Grand Total
                            </div>

                            {/* Column 2 - Inv Cost */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {formatRupees(grandTotal?.Amount || grandTotal?.totalInvCost || 0)}
                            </div>

                            {/* Column 3 - Current Value / Load Free Unit */}
                            <div style={{ width: "14%" }} className="fw-bold text-end">
                              {formatRupees(isGrandtotal || grandTotal?.totalMarketValue || 0)}
                            </div>

                            {/* Column 4 - Gain/Loss */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {formatRupees(grandTotal?.Gainloss || grandTotal?.totalGainLoss || 0)}
                            </div>

                            {/* Column 5 - CAGR */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {/* {grandTotal?.Cagr ?? "N/A"} */}
                            </div>

                            {/* Column 6 - Abs Return */}
                            <div style={{ width: "10%" }} className="fw-bold text-end">
                              {/* {grandTotal?.["Abs Return"] ?? "N/A"} */}
                            </div>

                            {/* Column 7 - Goal */}
                            <div style={{ width: "10%" }}></div>

                            {/* Column 8 - Action */}
                            <div style={{ width: "16%" }}></div>
                          </div>
                        </div>


                        {/* For Mobile view  Start*/}

                        <div className="row my-5 d-block d-md-none">
                          <div className=" border-color-green px-3 rounded-3 clrgreenlight">
                            <div className="d-flex justify-content-between my-3  ">
                              <strong>Grand Total</strong>

                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Inv Cost</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.Amount || grandTotal?.totalInvCost || 0)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Current Val</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.CurrentValue)}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between my-3  ">
                              <span>Gain/Loss</span>
                              <span className="text-color-green">
                                {formatRupees(grandTotal?.Gainloss || grandTotal?.totalGainLoss)}
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* For Mobile view End */}

                      </>
                    )}

                    <div id="actiocentercls" style={{ textAlign: "center" }}>
                      {/* {allowedReview && ( */}
                      {/* <>
                        {prst === "Draft" && (
                          <button
                            className="lrgbutton upercase  text-white"
                            id="validatesubmit"
                            onClick={handleSendPortFolio}
                          >
                            Send
                          </button>
                        )}
                        {(prst === "Failed" || prst === "Rejected") && (
                          <button
                            className="lrgbutton upercase  text-white"
                            id="validatesubmitresent"
                          >
                            Resend
                          </button>
                        )}
                      </> */}
                      {/* )} */}
                      {/* {allowDiscard && ( */}
                      {/* {prst === "Sent" &&
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="rechangeportfolio"
                          onClick={() => setIsShowDiscardReasonModal(true)}
                        >
                          Discard
                        </button>
                      } */}
                      {/* )} */}
                      {/* <button className="lrgbutton upercase  text-white ms-2" id="rechangeportfolio" onClick={()=>setIsShowDiscardReasonModal(true)}>
            Discard
            </button> */}

                      {/* {isPortfolioData?.data?.prinfo?.accepted_once && (
                        <button
                          className="lrgbutton upercase  text-white ms-2"
                          id="pushToArchive"
                        >
                          Archive
                        </button>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {!isPortfolioLoading && (
        <div className="container">
          <div className="row">
            <div className="col text-end">
              <a
                href="javascript:void(0);"
                onClick={handleBack}
                disabled={selectedTab === 1}
              >
                <img
                  className="arrow_next1"
                  src="/assets/images/left-arrowpng.png"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
